import { LinkOutbound, LinkRoute } from '@/components/common/Link'
import { ThemeSwitcher } from '@/components/common/ThemeSwitcher'
import { Icon } from '@/components/icons/Icon'
import { useQuickLinks } from '@/hooks/useQuickLinks'
import { trackEvent } from '@/utils/analyticsUtil'
import { cn } from '@/utils/commonUtil'

import styles from './MenuNavQuickLinks.module.scss'
import { MenuNavQuickLinksRandom } from './MenuNavQuickLinksRandom/MenuNavQuickLinksRandom'

export const MenuNavQuickLinks = () => {
  const quickLinks = useQuickLinks()

  const quickLinksFlat = quickLinks.flatMap((quickLink) =>
    quickLink.variant === 'submenu' ? quickLink.submenu : [quickLink],
  )

  const onClick = (href: string) => {
    trackEvent({ action: 'nav_click', category: 'menu_quick_link', label: href })
  }

  return (
    <ul className={styles.container}>
      {quickLinksFlat.map((item, i) => {
        if (item.variant === 'divider' || item.variant === 'submenu') return null

        if (item.variant === 'random') {
          return (
            <li className={styles.item} key={i}>
              <MenuNavQuickLinksRandom item={item} />
            </li>
          )
        }

        if (item.variant === 'theme-switcher') {
          return (
            <li className={styles.item} key={i}>
              <ThemeSwitcher className={styles.themeSwitcher} showLabel />
            </li>
          )
        }

        const { href, icon, label, newTab, superscript, variant } = item

        const Element = newTab ? LinkOutbound : LinkRoute

        return (
          href && (
            <li className={styles.item} key={i}>
              <Element
                className={cn(styles.link, { styles, variant })}
                href={href}
                onClick={() => onClick(item.href)}
                {...(newTab && { utm: { medium: 'navbar' } })}
              >
                <span className={styles.icon}>
                  <Icon name={icon} />
                </span>
                <span className={styles.label}>
                  {label}
                  {superscript && <sup>{superscript}</sup>}
                </span>
              </Element>
            </li>
          )
        )
      })}
    </ul>
  )
}
